import * as $runtime from "../runtime.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Partial from "../Partial/index.js";
import * as Specular$dInternal$dIncremental$dArray from "../Specular.Internal.Incremental.Array/index.js";
import * as Specular$dInternal$dIncremental$dEffect from "../Specular.Internal.Incremental.Effect/index.js";
import * as Specular$dInternal$dIncremental$dGlobal from "../Specular.Internal.Incremental.Global/index.js";
import * as Specular$dInternal$dIncremental$dMutableArray from "../Specular.Internal.Incremental.MutableArray/index.js";
import * as Specular$dInternal$dIncremental$dNode from "../Specular.Internal.Incremental.Node/index.js";
import * as Specular$dInternal$dIncremental$dOptional from "../Specular.Internal.Incremental.Optional/index.js";
import * as Specular$dInternal$dIncremental$dPriorityQueue from "../Specular.Internal.Incremental.PriorityQueue/index.js";
import * as Specular$dInternal$dIncremental$dRef from "../Specular.Internal.Incremental.Ref/index.js";
import * as Specular$dInternal$dProfiling from "../Specular.Internal.Profiling/index.js";
import * as Unsafe$dReference from "../Unsafe.Reference/index.js";
const max = x => y => {
  const v = Data$dOrd.ordInt.compare(x)(y);
  if (v.tag === "LT") { return y; }
  if (v.tag === "EQ") { return x; }
  if (v.tag === "GT") { return x; }
  $runtime.fail();
};
const Var = x => x;
const Event = x => x;
const uniqBy = (fn, a) => {
  const $0 = {
    compute: node => {
      const old = Specular$dInternal$dIncremental$dNode.get_value(node);
      const $$new = Specular$dInternal$dIncremental$dNode.get_value(a);
      if (
        !Unsafe$dReference.reallyUnsafeRefEq($$new)(Specular$dInternal$dIncremental$dOptional.none) && (
          Unsafe$dReference.reallyUnsafeRefEq(old)(Specular$dInternal$dIncremental$dOptional.none) || !fn(
            !Unsafe$dReference.reallyUnsafeRefEq(old)(Specular$dInternal$dIncremental$dOptional.none) ? old : Partial._crashWith("Optional.fromSome: none"),
            !Unsafe$dReference.reallyUnsafeRefEq($$new)(Specular$dInternal$dIncremental$dOptional.none) ? $$new : Partial._crashWith("Optional.fromSome: none")
          )
        )
      ) {
        return $$new;
      }
      return Specular$dInternal$dIncremental$dOptional.none;
    },
    dependencies: () => [a]
  };
  return Specular$dInternal$dIncremental$dNode.create($0);
};
const traceChanges = (fn, input) => {
  const $0 = {
    compute: _node => {
      const value_opt = Specular$dInternal$dIncremental$dNode.get_value(input);
      const isFiring = Specular$dInternal$dIncremental$dNode.isChangingInCurrentStabilization(input);
      if (isFiring) {
        fn(!Unsafe$dReference.reallyUnsafeRefEq(value_opt)(Specular$dInternal$dIncremental$dOptional.none) ? value_opt : Partial._crashWith("Optional.fromSome: none"));
      }
      return value_opt;
    },
    dependencies: () => [input]
  };
  return Specular$dInternal$dIncremental$dNode.create($0);
};
const sample = (fn, signal, clock) => {
  const $0 = {
    compute: _node => {
      const hasInput = Specular$dInternal$dIncremental$dNode.isChangingInCurrentStabilization(clock);
      if (hasInput) {
        const signal_value = Specular$dInternal$dIncremental$dNode.valueExc(signal);
        const clock_value = Specular$dInternal$dIncremental$dNode.valueExc(clock);
        return fn(signal_value, clock_value);
      }
      return Specular$dInternal$dIncremental$dOptional.none;
    },
    dependencies: () => [signal, clock]
  };
  return Specular$dInternal$dIncremental$dNode.create($0);
};
const readVar = v => v;
const readEvent = v => v;
const newVar = val => {
  const $0 = {compute: node => Specular$dInternal$dIncremental$dNode.valueExc(node), dependencies: () => []};
  const node = Specular$dInternal$dIncremental$dNode.create($0);
  Specular$dInternal$dIncremental$dNode.set_value(node, val);
  return node;
};
const newEvent = /* #__PURE__ */ (() => {
  const $0 = {compute: node => Specular$dInternal$dIncremental$dNode.get_value(node), dependencies: () => []};
  return () => Specular$dInternal$dIncremental$dNode.create($0);
})();
const mapOptional = (fn, a) => {
  const $0 = {
    compute: v => {
      const value_a = Specular$dInternal$dIncremental$dNode.get_value(a);
      return !Unsafe$dReference.reallyUnsafeRefEq(value_a)(Specular$dInternal$dIncremental$dOptional.none)
        ? fn(!Unsafe$dReference.reallyUnsafeRefEq(value_a)(Specular$dInternal$dIncremental$dOptional.none) ? value_a : Partial._crashWith("Optional.fromSome: none"))
        : Specular$dInternal$dIncremental$dOptional.none;
    },
    dependencies: () => [a]
  };
  return Specular$dInternal$dIncremental$dNode.create($0);
};
const mapN = (fn, inputs) => {
  const $0 = {
    compute: v => {
      const values = Specular$dInternal$dIncremental$dArray.mapE(inputs, Specular$dInternal$dIncremental$dNode.valueExc);
      return fn(values);
    },
    dependencies: () => inputs
  };
  return Specular$dInternal$dIncremental$dNode.create($0);
};
const map2 = (fn, a, b) => {
  const $0 = {
    compute: v => {
      const value_a = Specular$dInternal$dIncremental$dNode.valueExc(a);
      const value_b = Specular$dInternal$dIncremental$dNode.valueExc(b);
      return fn(value_a, value_b);
    },
    dependencies: () => [a, b]
  };
  return Specular$dInternal$dIncremental$dNode.create($0);
};
const map = (fn, a) => {
  const $0 = {
    compute: v => {
      const value_a = Specular$dInternal$dIncremental$dNode.valueExc(a);
      return fn(value_a);
    },
    dependencies: () => [a]
  };
  return Specular$dInternal$dIncremental$dNode.create($0);
};
const leftmost = inputs => {
  const $0 = {
    compute: _node => Specular$dInternal$dIncremental$dEffect.foreachUntil(
      inputs,
      input => {
        const isFiring = Specular$dInternal$dIncremental$dNode.isChangingInCurrentStabilization(input);
        if (isFiring) { return Specular$dInternal$dIncremental$dNode.get_value(input); }
        return Specular$dInternal$dIncremental$dOptional.none;
      }
    ),
    dependencies: () => inputs
  };
  return Specular$dInternal$dIncremental$dNode.create($0);
};
const isTracing = false;
const trace = v => () => {};
const globalRecomputeQueue = /* #__PURE__ */ Specular$dInternal$dIncremental$dPriorityQueue.new(
  Specular$dInternal$dIncremental$dOptional.none,
  "height",
  "inRecomputeQueue",
  "nextInRecomputeQueue"
);
const setVar = (v, val) => {
  Specular$dInternal$dIncremental$dNode.set_value(v, val);
  Specular$dInternal$dIncremental$dPriorityQueue.add(globalRecomputeQueue, v);
};
const triggerEvent = (v, val) => {
  Specular$dInternal$dIncremental$dNode.set_value(v, val);
  Specular$dInternal$dIncremental$dPriorityQueue.add(globalRecomputeQueue, v);
};
const fold = (fn, initial, a) => {
  const $0 = {
    compute: node => {
      const state_opt = Specular$dInternal$dIncremental$dNode.get_value(node);
      const state = (() => {
        if (!Unsafe$dReference.reallyUnsafeRefEq(state_opt)(Specular$dInternal$dIncremental$dOptional.none)) {
          if (!Unsafe$dReference.reallyUnsafeRefEq(state_opt)(Specular$dInternal$dIncremental$dOptional.none)) { return state_opt; }
          return Partial._crashWith("Optional.fromSome: none");
        }
        return initial;
      })();
      const hasInput = Specular$dInternal$dIncremental$dNode.isChangingInCurrentStabilization(a);
      if (hasInput) {
        const input = Specular$dInternal$dIncremental$dNode.valueExc(a);
        return fn(input, state);
      }
      return state;
    },
    dependencies: () => [a]
  };
  return Specular$dInternal$dIncremental$dNode.create($0);
};
const ensureHeight = (node, newHeight) => {
  const oldAdjustedHeight = Specular$dInternal$dIncremental$dNode.get_adjustedHeight(node);
  return Specular$dInternal$dIncremental$dNode.set_adjustedHeight(node, max(oldAdjustedHeight)(newHeight));
};
const recomputeNode = node => {
  const height = Specular$dInternal$dIncremental$dNode.get_height(node);
  const adjustedHeight = Specular$dInternal$dIncremental$dNode.get_adjustedHeight(node);
  if (adjustedHeight > height) {
    const mark = Specular$dInternal$dProfiling.begin("bump height " + Specular$dInternal$dIncremental$dNode.get_name(node));
    const dependents = Specular$dInternal$dIncremental$dNode.get_dependents(node);
    Specular$dInternal$dIncremental$dMutableArray.iterate(
      dependents,
      dependent => {
        const $0 = adjustedHeight + 1 | 0;
        return ensureHeight(dependent, $0);
      }
    );
    Specular$dInternal$dIncremental$dNode.set_height(node, adjustedHeight);
    Specular$dInternal$dIncremental$dPriorityQueue.add(globalRecomputeQueue, node);
    return Specular$dInternal$dProfiling.end(mark);
  }
  const mark = Specular$dInternal$dProfiling.begin("compute " + Specular$dInternal$dIncremental$dNode.get_name(node));
  const source = Specular$dInternal$dIncremental$dNode.get_source(node);
  const newValue_opt = source.compute(node);
  if (!Unsafe$dReference.reallyUnsafeRefEq(newValue_opt)(Specular$dInternal$dIncremental$dOptional.none)) {
    const newValue = !Unsafe$dReference.reallyUnsafeRefEq(newValue_opt)(Specular$dInternal$dIncremental$dOptional.none)
      ? newValue_opt
      : Partial._crashWith("Optional.fromSome: none");
    Specular$dInternal$dIncremental$dNode.set_value(node, newValue);
    const currentStabilizationNum = Specular$dInternal$dIncremental$dRef.read(Specular$dInternal$dIncremental$dGlobal.globalCurrentStabilizationNum);
    Specular$dInternal$dIncremental$dNode.set_changedAt(node, currentStabilizationNum);
    const dependents = Specular$dInternal$dIncremental$dNode.get_dependents(node);
    Specular$dInternal$dIncremental$dMutableArray.iterate(dependents, dependent => {Specular$dInternal$dIncremental$dPriorityQueue.add(globalRecomputeQueue, dependent);});
    const observers = Specular$dInternal$dIncremental$dNode.get_observers(node);
    Specular$dInternal$dIncremental$dMutableArray.iterate(observers, observer => observer(newValue));
  }
  return Specular$dInternal$dProfiling.end(mark);
};
const stabilize = () => {
  const mark = Specular$dInternal$dProfiling.begin("stabilize");
  const oldStabilizationNum = Specular$dInternal$dIncremental$dRef.read(Specular$dInternal$dIncremental$dGlobal.globalLastStabilizationNum);
  const currentStabilizationNum = oldStabilizationNum + 1 | 0;
  Specular$dInternal$dIncremental$dRef.write(Specular$dInternal$dIncremental$dGlobal.globalLastStabilizationNum, currentStabilizationNum);
  Specular$dInternal$dIncremental$dRef.write(Specular$dInternal$dIncremental$dGlobal.globalCurrentStabilizationNum, currentStabilizationNum);
  Specular$dInternal$dIncremental$dPriorityQueue.drain(globalRecomputeQueue, recomputeNode);
  Specular$dInternal$dIncremental$dRef.write(Specular$dInternal$dIncremental$dGlobal.globalCurrentStabilizationNum, -1);
  return Specular$dInternal$dProfiling.end(mark);
};
const effectCrash = msg => v => Partial._crashWith(msg);
const constant = value => Specular$dInternal$dIncremental$dNode.create({compute: v => value, dependencies: () => []});
const removeDependent = (node, dependent) => {
  const oldRefcount = Specular$dInternal$dIncremental$dNode.refcount(node);
  const dependents = Specular$dInternal$dIncremental$dNode.get_dependents(node);
  Specular$dInternal$dIncremental$dMutableArray.remove(dependents, dependent);
  return handleRefcountChange(node, oldRefcount);
};
const handleRefcountChange = (node, oldRefcount) => {
  const newcount = Specular$dInternal$dIncremental$dNode.refcount(node);
  if (oldRefcount === 0 && newcount > 0) {
    connect(node);
  } else if (oldRefcount > 0 && newcount === 0) { disconnect(node); }
  const oldTotalRefcount = Specular$dInternal$dIncremental$dRef.read(Specular$dInternal$dIncremental$dGlobal.globalTotalRefcount);
  return Specular$dInternal$dIncremental$dRef.write(Specular$dInternal$dIncremental$dGlobal.globalTotalRefcount, (oldTotalRefcount - oldRefcount | 0) + newcount | 0);
};
const disconnect = node => {
  const $0 = "disconnect " + Specular$dInternal$dIncremental$dNode.get_name(node);
  const mark = Specular$dInternal$dProfiling.begin($0);
  const source = Specular$dInternal$dIncremental$dNode.get_source(node);
  const dependencies = source.dependencies();
  Specular$dInternal$dIncremental$dArray.iterate(dependencies, dependency => removeDependent(dependency, node));
  return Specular$dInternal$dProfiling.end(mark);
};
const connect = node => {
  const $0 = "connect " + Specular$dInternal$dIncremental$dNode.get_name(node);
  const mark = Specular$dInternal$dProfiling.begin($0);
  const source = Specular$dInternal$dIncremental$dNode.get_source(node);
  const dependencies = source.dependencies();
  Specular$dInternal$dIncremental$dArray.iterate(
    dependencies,
    dependency => {
      addDependent(dependency, node);
      const dependencyHeight = Specular$dInternal$dIncremental$dNode.get_height(dependency);
      const adjustedHeight = Specular$dInternal$dIncremental$dNode.get_adjustedHeight(node);
      const ourHeight = Specular$dInternal$dIncremental$dNode.get_height(node);
      const desiredHeight = max(dependencyHeight + 1 | 0)(adjustedHeight);
      if (desiredHeight > ourHeight) {
        Specular$dInternal$dIncremental$dNode.set_height(node, desiredHeight);
        return Specular$dInternal$dIncremental$dNode.set_adjustedHeight(node, desiredHeight);
      }
    }
  );
  const value = source.compute(node);
  Specular$dInternal$dIncremental$dNode.set_value(node, value);
  return Specular$dInternal$dProfiling.end(mark);
};
const addDependent = (node, dependent) => {
  const oldRefcount = Specular$dInternal$dIncremental$dNode.refcount(node);
  const dependents = Specular$dInternal$dIncremental$dNode.get_dependents(node);
  Specular$dInternal$dIncremental$dMutableArray.push(dependents, dependent);
  return handleRefcountChange(node, oldRefcount);
};
const addObserver = (node, observer) => {
  const oldRefcount = Specular$dInternal$dIncremental$dNode.refcount(node);
  const observers = Specular$dInternal$dIncremental$dNode.get_observers(node);
  Specular$dInternal$dIncremental$dMutableArray.push(observers, observer);
  return handleRefcountChange(node, oldRefcount);
};
const removeObserver = (node, observer) => {
  const oldRefcount = Specular$dInternal$dIncremental$dNode.refcount(node);
  const observers = Specular$dInternal$dIncremental$dNode.get_observers(node);
  Specular$dInternal$dIncremental$dMutableArray.remove(observers, observer);
  return handleRefcountChange(node, oldRefcount);
};
const $$switch = (alwaysFire, lhs, fn) => {
  const main_node_ref = Specular$dInternal$dIncremental$dRef.new(Specular$dInternal$dIncremental$dOptional.none);
  const rhs_node = Specular$dInternal$dIncremental$dNode.create({
    compute: node => {
      const value_lhs = Specular$dInternal$dIncremental$dNode.valueExc(lhs);
      const rhs = fn(value_lhs);
      const main_opt = Specular$dInternal$dIncremental$dRef.read(main_node_ref);
      const main = !Unsafe$dReference.reallyUnsafeRefEq(main_opt)(Specular$dInternal$dIncremental$dOptional.none) ? main_opt : Partial._crashWith("Optional.fromSome: none");
      addDependent(rhs, main);
      const dependencyHeight = Specular$dInternal$dIncremental$dNode.get_height(rhs);
      ensureHeight(main, dependencyHeight + 1 | 0);
      const old_rhs_opt = Specular$dInternal$dIncremental$dNode.get_value(node);
      if (!Unsafe$dReference.reallyUnsafeRefEq(old_rhs_opt)(Specular$dInternal$dIncremental$dOptional.none)) {
        removeDependent(
          !Unsafe$dReference.reallyUnsafeRefEq(old_rhs_opt)(Specular$dInternal$dIncremental$dOptional.none) ? old_rhs_opt : Partial._crashWith("Optional.fromSome: none"),
          main
        );
      }
      return rhs;
    },
    dependencies: () => [lhs]
  });
  Specular$dInternal$dIncremental$dNode.annotate(rhs_node, "switch data");
  const main = Specular$dInternal$dIncremental$dNode.create({
    compute: v => {
      const rhs = Specular$dInternal$dIncremental$dNode.valueExc(rhs_node);
      const isFiring = Specular$dInternal$dIncremental$dNode.isChangingInCurrentStabilization(rhs);
      if (alwaysFire || isFiring) { return Specular$dInternal$dIncremental$dNode.get_value(rhs); }
      return Specular$dInternal$dIncremental$dOptional.none;
    },
    dependencies: () => {
      const rhs_opt = Specular$dInternal$dIncremental$dNode.get_value(rhs_node);
      if (!Unsafe$dReference.reallyUnsafeRefEq(rhs_opt)(Specular$dInternal$dIncremental$dOptional.none)) {
        return [rhs_node, !Unsafe$dReference.reallyUnsafeRefEq(rhs_opt)(Specular$dInternal$dIncremental$dOptional.none) ? rhs_opt : Partial._crashWith("Optional.fromSome: none")];
      }
      return [rhs_node];
    }
  });
  Specular$dInternal$dIncremental$dRef.write(main_node_ref, main);
  return main;
};
const bind_ = (lhs, fn) => $$switch(true, lhs, fn);
export {
  Event,
  Var,
  addDependent,
  addObserver,
  bind_,
  connect,
  constant,
  disconnect,
  effectCrash,
  ensureHeight,
  fold,
  globalRecomputeQueue,
  handleRefcountChange,
  isTracing,
  leftmost,
  map,
  map2,
  mapN,
  mapOptional,
  max,
  newEvent,
  newVar,
  readEvent,
  readVar,
  recomputeNode,
  removeDependent,
  removeObserver,
  sample,
  setVar,
  stabilize,
  $$switch as switch,
  trace,
  traceChanges,
  triggerEvent,
  uniqBy
};
